import {connect} from 'react-redux';
import { actions } from 'forms/rrf';
import { Col, Row } from 'react-bootstrap';
import Store from './store';
import AddStore from './add-store';
import { history } from '../../store';

const StoreList = ({
  stores, fetched, fetching, dispatch, registration
}) => {
  const onAddStoreClicked = () => {
    if (history.location.pathname.startsWith('/registration/')) {
      dispatch(actions.reset('deep.registration.outlet_validation'));
      dispatch(actions.reset('deep.yourStore'));
      history.push('/registration/outlet');
    } else {
      dispatch({type: 'START_REGISTRATION_INTERNAL'});
      history.push('/outlet');
    }
  };

  if (!fetched && fetching) {
    return (<h1>Loading...</h1>);
  }

  return (
    <div className="store-list">
      <Row>
        <Col md={{span: 4, order: 'last'}}>
          <Row>
            <AddStore key="-1" onAddStoreClicked={onAddStoreClicked} registration={registration} />
          </Row>
        </Col>
        <Col md={{span: 8, order: 'first'}}>
          <Row>
            {stores.filter(store => store.type === 'outlets').map(store => (
              <Store
                key={store.id}
                outlet={store}
                registration={registration}
              />
            ))}
          </Row>
          <Row>
            {stores.filter(store => store.type === 'pending-outlets').map(store => (
              <Store
                key={store.id}
                outlet={store}
                registration={registration}
              />
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default connect()(StoreList);
